define.alias("shared/components/shared/plan-recommendation/progress-bar", "settings/components/shared/plan-recommendation/progress-bar");